// extracted by mini-css-extract-plugin
export default {"legendIconItem":"LegendIconItem-legendIconItem-HRUQm","icon":"LegendIconItem-icon-GfrY5"};